import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid'; // Import Grid
import FileOpenOutlinedIcon from '@mui/icons-material/FileOpenOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

function ContextMenu({ open, position, file, onClose }) {
  const options = [
    { label: 'Open', action: 'open', icon: <FileOpenOutlinedIcon /> },
    { label: 'Download', action: 'download', icon: <FileDownloadOutlinedIcon /> },
    { label: 'Rename', action: 'rename', icon: <DriveFileRenameOutlineOutlinedIcon /> },
    { label: 'Delete', action: 'delete', icon: <DeleteOutlineOutlinedIcon /> },
  ];

  const handleClick = (option) => {
    // Handle the selected context menu option
    if (option === 'open') {
      // Implement open functionality
    } else if (option === 'download') {
      // Implement download functionality
    } else if (option === 'rename') {
      // Implement rename functionality
    } else if (option === 'delete') {
      // Implement delete functionality
    }

    // Close the context menu
    onClose();
  };

  if (!open) {
    return null;
  }

  return (
    <Menu
      anchorReference="anchorPosition"
      anchorPosition={{ top: position.top, left: position.left, position:"absolute" }}
      open={open}
      onClose={onClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1.5,
          minWidth: '200px',
        },
      }}
    >
      {/* Responsive Grid layout */}
      <Grid container spacing={1} alignItems="center">
        {options.map((option) => (
          <Grid item xs={12} key={option.action}>
            <MenuItem onClick={() => handleClick(option.action)}>
              <IconButton color="inherit" size="small">
                {option.icon}
              </IconButton>
              {option.label}
            </MenuItem>
          </Grid>
        ))}
      </Grid>
    </Menu>
  );
}

export default ContextMenu;